import { __awaiter } from "tslib";
import Vue from 'vue';
import { mapGetters } from 'vuex';
import SERVICE_CONSTANTS, { getServiceConfigProperty } from '@/constants/services';
import { openChaportChat } from '@/utils/chaport';
import { getPassportUrl } from '@/utils/other';
import UUID from '@/components/global/top-bar/UUID.vue';
export default Vue.extend({
    name: 'mobUserBar',
    components: { UUID },
    data() {
        return {
            baseKnowledgeLink: ''
        };
    },
    props: {
        disabled: {
            type: Boolean
        },
        menuData: {
            type: Object,
            required: true
        },
        menuElError: {
            type: Boolean,
            required: true
        },
        menuLoaded: {
            type: Boolean,
            required: true
        }
    },
    beforeMount() {
        this.getKnowledgeBaseFaqLink();
    },
    computed: Object.assign(Object.assign(Object.assign({}, mapGetters('user', ['getUserData'])), mapGetters('screener', ['getAccessesScreener'])), { getUserFullname() {
            var _a;
            const vm = this;
            return vm.getUserData.last_name + ' ' + vm.getUserData.first_name + ' ' + ((_a = vm.getUserData.patronymic) !== null && _a !== void 0 ? _a : '');
        }, menuList() {
            const total = [
                { title: 'Мой аккаунт', to: getPassportUrl('/id', { withAcceptor: true }), isOut: true, id: 'account', disableble: false, key: 'account', defaultVisible: true },
                { title: 'Скринер', to: SERVICE_CONSTANTS.NEW_BINANCE + '/screener', isOut: true, id: 'screener', disableble: true, hide: false, isNew: true, key: 'screener', defaultVisible: false },
                { title: 'Веб-терминал', to: SERVICE_CONSTANTS.NEW_BINANCE + '/web-terminal', isOut: true, id: 'webTerminal', disableble: true, hide: false, isNew: true, key: 'webTerminal', defaultVisible: false },
                { title: 'Бонусы', to: SERVICE_CONSTANTS.NEW_BINANCE + '/bonuses', isOut: true, id: 'bonuses', disableble: true, key: 'bonus', defaultVisible: false },
                { title: 'Терминал Scalpee', to: SERVICE_CONSTANTS.NEW_BINANCE + '/download-terminal', isOut: true, id: 'terminal', disableble: true, key: 'terminal', defaultVisible: false },
                { title: 'Терминалы LiSA и Project AZ', to: SERVICE_CONSTANTS.NEW_BINANCE + '/download-terminal-lisa', isOut: true, id: 'terminalLisa', disableble: true, key: 'terminalLisa', defaultVisible: false },
                { title: 'Buddy', to: { name: 'buddy' }, isOut: false, id: 'buddy', disableble: true, key: 'buddy', defaultVisible: false },
                { title: 'Белый список', to: { name: 'whitelists' }, isOut: false, id: 'whitelist', disableble: true, key: 'whitelist', defaultVisible: false },
                { title: 'Сообщество', to: SERVICE_CONSTANTS.NEW_BINANCE + '/community', isOut: true, id: 'community', disableble: true, hide: false, isNew: true, key: 'community', defaultVisible: false },
                { title: 'База знаний', to: this.baseKnowledgeLink, isOut: true, id: 'docs', disableble: true, hide: !this.baseKnowledgeLink.length, isNew: false, target: '_blank', defaultVisible: false }
            ];
            return this.menuElError || !this.menuLoaded ? total.filter((el) => el.defaultVisible) : total;
        } }),
    methods: {
        showElement(key) {
            if (this.menuData[key]) {
                return this.menuData[key].state === 'visible';
            }
            else {
                return true;
            }
        },
        showBadge(key) {
            return (Boolean(this.menuData[key]) &&
                Boolean(this.menuData[key].badge) &&
                Boolean(this.menuData[key].badge.text !== '') &&
                this.menuData[key].badge.state !== 'hidden');
        },
        handleSupportClick() {
            const vm = this;
            vm.$emit('onClick');
            let content = vm.$t('popups.content.textUsLisa');
            const actions = [{
                    title: 'Чат',
                    isAccent: true,
                    callback() {
                        vm.$store.commit('popupModule/setClosed');
                        openChaportChat({
                            name: vm.getUserData.last_name + ' ' + vm.getUserData.first_name + ' ' + vm.getUserData.patronymic,
                            email: vm.getUserData.email,
                            phone: vm.getUserData.phone,
                            notes: `${vm.$t('popups.content.traderProfile')} ${document.title}`
                        });
                    }
                }];
            if (getServiceConfigProperty('companyAbrv') !== 'LiSA') {
                actions.push({
                    title: 'Telegram',
                    isAccent: false,
                    callback() {
                        vm.$store.commit('popupModule/setClosed');
                        window.open('https://t.me/WhitelistCapital_bot', '_blank');
                    }
                });
                content = vm.$t('popups.content.textUs');
            }
            vm.$store.dispatch('popupModule/openPopup', {
                type: 'confirmPopup',
                letDefaultClose: true,
                title: vm.$t('popups.titles.haveAQuestion'),
                content,
                actions
            });
        },
        preLogout() {
            const vm = this;
            vm.$emit('onClick');
            vm.$store.dispatch('popupModule/openPopup', {
                type: 'action',
                letDefaultClose: false,
                title: vm.$t('popups.titles.confirmation'),
                content: vm.$t('popups.content.wannaExit'),
                actions: [
                    {
                        title: vm.$t('popups.actions.stay'),
                        isAccent: false,
                        callback() { vm.$store.commit('popupModule/setClosed'); }
                    },
                    {
                        title: vm.$t('popups.actions.yepExit'),
                        isAccent: true,
                        callback() {
                            vm.$store.commit('popupModule/setClosed');
                            vm.logout();
                        }
                    }
                ]
            });
        },
        getKnowledgeBaseFaqLink() {
            return __awaiter(this, void 0, void 0, function* () {
                const slug = 'base';
                const vm = this;
                const { data } = yield vm.services.mainService.getFaqLinkBySlugName(slug);
                this.baseKnowledgeLink = data[slug].link;
            });
        },
        logout() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                const cookie = vm.$cookies.get('jwtr');
                const response = yield vm.services.authorization.logout({ refresh: cookie });
                const location = window.location;
                const host = location.hostname.split('.').reverse()[1] + '.' + location.hostname.split('.').reverse()[0];
                if (response.success) {
                    vm.$cookies.set('jwtr', '', {
                        expires: -1,
                        domain: '.' + host
                    });
                    window.location.href = getPassportUrl('/', { withAcceptor: true });
                }
            });
        }
    }
});
